import addCalendarEventsAttachment from '../actions/addCalendarEventsAttachment';
import addCompletedAction from '../actions/addCompletedAction';
import setOngoingActionAndActionMessage from '../actions/setOngoingActionAndActionMessage';
import AddToCalendarSource from '../schema/AddToCalendarSource';
import { stopFakeProgressIndicator } from '../utils/FakeProgressIndicator';
import { ActionMessageId, ActionType, AttachmentFullViewState } from 'owa-attachment-full-data';
import importCalendarEventService from 'owa-calendar-services/lib/services/importCalendarEventService';
import { ClientAttachmentId } from 'owa-client-ids';
import ImportCalendarEventResponseMessage from 'owa-service/lib/contract/ImportCalendarEventResponseMessage';
import { orchestrator } from 'satcheljs';

// exporting it for the testing purpose
export default orchestrator(addCalendarEventsAttachment, async actionMessage => {
    addToCalendarPreProcess(actionMessage.attachment);
    let response: ImportCalendarEventResponseMessage;
    try {
        response = await importCalendarEventService(
            null /* content */,
            null /* importedItemFolderId */,
            actionMessage.attachment.attachmentId.Id
        );
    } catch {}

    const eventSucessState =
        response && response.ResponseClass === 'Success'
            ? ActionMessageId.ImportToCalendarCompletedWithIcon
            : ActionMessageId.ImportToCalendarFailedWithIcon;

    addToCalendarPostProcess(
        actionMessage.attachment.attachmentId,
        eventSucessState,
        actionMessage.attachment,
        ActionType.None,
        ActionType.AddToCalendar
    );
});

// Explicitely exporitng AddToCalendarSource as this enum, which is passed from subscribed action, is private to this file
export { AddToCalendarSource };

function addToCalendarPreProcess(attachment: AttachmentFullViewState) {
    setOngoingActionAndActionMessage(
        attachment,
        ActionType.AddToCalendar,
        ActionMessageId.ImportToCalendarInProgress
    );
}

function addToCalendarPostProcess(
    attachmentId: ClientAttachmentId,
    eventSucessState: ActionMessageId,
    attachment: AttachmentFullViewState,
    onGoingActionType: ActionType,
    completedActionType: ActionType
) {
    stopFakeProgressIndicator(attachmentId, true);
    addCompletedAction(attachment, completedActionType);
    setOngoingActionAndActionMessage(attachment, onGoingActionType, eventSucessState);
}
